module.exports = __webpack_public_path__ + "img/Egerton.98cc00cb.png";